<div
  class="bday"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'birthdayCelebration.title' | translate: { name: firstName() }"
>
  <div class="bday__confetti" aria-hidden="true">
    @for (p of pieces; track p.id) {
      <span
        class="bday__piece"
        [style.left]="p.left"
        [style.animation-delay]="p.delay"
        [style.animation-duration]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 0.55"
        [style.background]="'hsl(' + p.hue + ' 75% 55%)'"
      ></span>
    }
  </div>

  <div class="bday__card">
    <p class="bday__eyebrow">{{ 'birthdayCelebration.eyebrow' | translate }}</p>
    <h1 class="bday__title">
      {{ 'birthdayCelebration.title' | translate: { name: firstName() } }}
    </h1>
    <p class="bday__message">{{ message() }}</p>
    <button type="button" mat-flat-button color="primary" class="bday__cta" (click)="onDismiss()">
      {{ 'birthdayCelebration.thanks' | translate }}
    </button>
  </div>
</div>
